export default __webpack_public_path__ + "static/media/service-managemnt.7f4a5d50.jpg";